// extracted by mini-css-extract-plugin
module.exports = {"container":"Aniversariantes_container__1uBjL","aniversariantes":"Aniversariantes_aniversariantes__1GRda","data":"Aniversariantes_data__3xxer"};